import React from 'react'
import SubLayout from '../../components/Layout/SubLayout';
import strings from '../../components/Language';

//  CSS
import './../../assets/styles/style.scss';
import './invitelink.scss';
import logo from './../../assets/images/front/ctsbotLogo.png';

import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from './../../components/config/api.js';
import { getToken, storeUserData } from './../../components/Util';
import _ from 'lodash';
import QRCode from "react-qr-code";
import LoaderContext from '../../components/Loader/LoaderContext.js';

class InviteLinkScreen extends React.Component {
    static contextType = LoaderContext;
    constructor(props) {
        super(props);
        this.wrapper = React.createRef();
        this.state = {
            access_token: "",
            user_data: {},
        }
    }

    async componentDidMount() {
        var token = await getToken();
        if (token) {
            await storeUserData(token);
            this.setState({ access_token: token });
            setTimeout(() => {
                this.getData();
            });
        }
    }

    getData() {
        const { setLoading } = this.context;
        var self = this;
        setLoading(true);
        axios({
            method: 'GET',
            url: api.profile_show,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json',
                'Accept-Language': strings.getLanguage(),
            }
        }).then(function (ress) {
            if (ress.data && ress.data.error === 200) {

                self.setState({ user_data: ress.data.data });
            } else {
                if (ress.data.validation && ress.data.validation.length !== 0) {

                    _.forEach(ress.data.validation, function (value) {
                        if (value[0]) {
                            toast.error(value[0]);
                        }
                    });
                } else {
                    toast.error(ress.data.message);
                }
            }
            setLoading(false);
        }).catch(function (e) {
            setLoading(false);
        });
    };

    copyCode() {
        navigator.clipboard.writeText((this.state.user_data && this.state.user_data.invitation_code) ? this.state.user_data.invitation_code : '');
        toast.success(strings.code_copy_successfully);
    }

    copyRegistrationLink() {
        if (this.state.user_data && this.state.user_data.invitation_code) {
            navigator.clipboard.writeText(window.location.origin + `/register?invitationcode=${this.state.user_data.invitation_code}`);
            toast.success(strings.link_copy_successfully);
        }
    }

    render() {
        const invitationCode = (this.state.user_data && this.state.user_data.invitation_code) ? this.state.user_data.invitation_code : '';
        const registrationLink = invitationCode ? `${window.location.origin}/register?invitationcode=${invitationCode}` : '';

        return (
            <>
                <SubLayout ref={this.wrapper} data={{ "title": strings.invite_friend }}>
                    <div className="invite-page">
                        <div className="invite-shell">
                            <section className="invite-card">
                                <div className="invite-card-top">
                                    <img className="invite-logo" alt="CTS Bot" src={logo} />
                                    <div className="invite-badge">{strings.invite_friend}</div>
                                </div>

                                <div className="invite-heading">
                                    <h1>Invite friends</h1>
                                    <p>Share your code or link so new users can register under your network.</p>
                                </div>

                                <div className="invite-main-grid">
                                    <div className="invite-qr-panel">
                                        <div className="qr_code invite-qr-box">
                                            <QRCode size={170} value={registrationLink} />
                                        </div>
                                        <span className="invite-qr-label">Scan this QR to register</span>
                                    </div>

                                    <div className="invite-content">
                                        <div className="invite-code-block">
                                            <span>{strings.my_invitation_code}</span>
                                            <strong>{invitationCode || '--'}</strong>
                                        </div>

                                        <div className="invite-link-block">
                                            <span>Registration Link</span>
                                            <div>{registrationLink || '--'}</div>
                                        </div>

                                        <div className="invite-actions">
                                            <button type="button" onClick={() => this.copyCode()} className="invite-primary-btn">
                                                {strings.code_copy}
                                            </button>
                                            <button type="button" onClick={() => this.copyRegistrationLink()} className="invite-secondary-btn">
                                                {strings.copy_link}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </SubLayout>
            </>
        );
    }
}

export default InviteLinkScreen;
